import { Routes } from '@angular/router';
import { AppLayout } from './layout/component/app.layout';
import { Dashboard } from './pages/dashboard/dashboard';
import { Documentation } from './pages/documentation/documentation';
import { Landing } from './pages/landing/landing';
import { Notfound } from './pages/notfound/notfound';
import { PrivacyPolicyComponent } from './pages/static/privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './pages/static/terms-condition/terms-condition.component';

export const routes: Routes = [
    {
        path: '',
        component: AppLayout,
        children: [
            { path: '', component: Dashboard },
            { path: 'kundali', loadChildren: () => import('./pages/kundali/kundali.routes') },
            { path: 'profile', loadChildren: () => import('./pages/profile/profile.routes') },
            { path: 'privacy-policy', component: PrivacyPolicyComponent },
            { path: 'terms-condition', component: TermsConditionComponent },
            // { path: 'uikit', loadChildren: () => import('./pages/uikit/uikit.routes') },
            // { path: 'documentation', component: Documentation },
            // { path: 'pages', loadChildren: () => import('./pages/pages.routes') }
        ]
    },
    { path: 'auth', loadChildren: () => import('./pages/auth/auth.routes') },
    { path: 'landing', component: Landing },
    { path: 'notfound', component: Notfound },
    
    { path: '**', redirectTo: '/notfound' }
];
